// src/app/shared/guards/necta-system-admin.guard.ts

import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree
} from '@angular/router';
import { AuthService } from '../services/auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class NectaSystemAdminGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    const isAdmin = this.authService.isNectaSystemAdministrator();
    if (isAdmin) {
      return true;
    }
    // Wenn nicht NectaSystemAdministrator, weiterleiten oder 403-Seite anzeigen
    return this.router.parseUrl('/forbidden');
  }
}
